// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1978":"4ebae98fc6dc3ad8","9617":"df68d39f37ca35f3"}[chunkId] + ".js";
};